<template>
  <div class="description">
  An event must have at least one day for the actual meetings.
  <br/>
  You can add as many days as you want.
  <br/>
  Specify the number of days of meetings for this event, then specify the details of each day.
  <br/>You can always change this later
  </div>

  <div class="content">
    <div class="days-input">
      <v-text-field
        class="custom-input"
        bg-color="white"
        density="compact"
        type="number"
        :model-value="wizard.eventDays"
        @update:model-value="
          if (+$event && +$event > 0 && +$event >= wizard.days.length) wizard.eventDays = +$event;
        "
        color="primary"
        label="Number of Days"
        :disabled="wizard.loading"
        data-cy="event-days-number"
      ></v-text-field>
    </div>

    <div class="days-con">
      <div
        class="day-item"
        v-for="(day, i) in sort(wizard.days, (i) => i.start_time.toISOString())"
        :key="i"
      >
        <div class="title">Day {{ i + 1 }}</div>
        <div class="date">
          {{ dayjs(day.start_time).format("MM/DD/YYYY") }}
        </div>
        <div class="time-range">
          {{ dayjs(day.start_time).format("h:mm A") }} -
          {{ dayjs(day.end_time).format("h:mm A") }}
        </div>
        <div class="interval">{{ day.interval }}m Interval</div>
        <div class="delete-btn">
          <v-btn
            @click="
              wizard.days.splice(wizard.days.indexOf(day), 1);
              wizard.eventDays = wizard.eventDays - 1 || 1;
            "
            color="normal"
            icon
            style="max-width: 30px; max-height: 30px"
            :disabled="wizard.loading"
          >
            <v-tooltip activator="parent" location="bottom">Delete this day</v-tooltip>
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <div class="days-table mt-4" v-if="!wizard.step.finished()">
      <div class="event-days-table table-overflow-hide">
        <div class="directoryTable scrollable-55vh" style="max-height: 55vh; height: auto">
          <table class="table">
            <thead class="sticky-header">
              <tr>
                <th>Date</th>
                <th>From</th>
                <th>To</th>
                <th>Interval</th>
              </tr>
            </thead>

            <tbody>
              <tr data-cy="wizard-day-form">
                <td>
                  <date-picker
                    color="primary"
                    v-model="wizard.newDay.start_time"
                    class="custom-input date"
                    density="compact"
                    type="date"
                    data-cy="wizard-day-date"
                  ></date-picker>
                </td>
                <td>
                  <date-picker
                    color="primary"
                    v-model="wizard.newDay.start_time"
                    class="custom-input date"
                    density="compact"
                    type="time"
                    data-cy="wizard-day-start"
                  ></date-picker>
                </td>
                <td>
                  <date-picker
                    color="primary"
                    v-model="wizard.newDay.end_time"
                    class="custom-input date"
                    density="compact"
                    type="time"
                    data-cy="wizard-day-end"
                  ></date-picker>
                </td>
                <td>
                  <v-text-field
                    color="primary"
                    class="custom-input number"
                    density="compact"
                    type="number"
                    :model-value="wizard.newDay.interval"
                    @update:model-value="
                      if (+$event && +$event > 0) wizard.newDay.interval = +$event;
                    "
                    data-cy="wizard-day-interval"
                  ></v-text-field>
                </td>
                <!-- <td>
                  <v-btn
                    @click="
                      wizard.days.splice(wizard.days.indexOf(day), 1);
                      wizard.eventDays--;
                    "
                    :disabled="i == 0 && wizard.eventDays === 1"
                    color="normal"
                    icon
                    style="max-width: 30px; max-height: 30px"
                  >
                    <v-tooltip activator="parent" location="bottom">Delete this day</v-tooltip>
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import DatePicker from "@/components/datePicker.vue";
import useWizard from "@/stores/school/wizard";
import { sort } from "@/utils/sort";
import dayjs from "dayjs";

const wizard = useWizard();
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.days-con {
  margin-top: 20px;
  overflow-x: auto;
  gap: 15px;
  display: flex;
  flex-direction: column;
  .day-item {
    display: flex;
    // align-items: center;
    gap: 10px;
    // overflow-x: ;
    // white-space: nowrap;

    .title {
      font-weight: 600;
      font-size: 1.1rem;
      white-space: nowrap;
    }
  }
}

.days-input {
  margin-top: 20px;
  width: 150px;
  max-width: 100%;
}

.small-col {
  width: 10px;
}

.custom-input.number {
  width: 70px;
}
.custom-input.date {
  width: 140px;
}

.table {
  td {
    width: unset !important;
  }
}
</style>
